module.exports = __webpack_public_path__ + "img/172.dec183de.jpg";